<div *ngLet="(canCopyFromPrevious$ | async) as canCopyFromPrevious" class="pageSubHeader">
  <app-section-title
    *ngIf="(screenSizeService.isHandset$ | async) === false"
    svgIcon="binoculars"
    [title]="forecastTitle"
    headerSize="h4"
  ></app-section-title>
  <div
    [matTooltip]="(canCopyFromPrevious ? StaticMessage.CopyFromPreviousDprTooltip : StaticMessage.CanNotCopyFirstDprTooltip) | staticMessage"
  >
    <button
      *ngIf="canEdit"
      [disabled]="!canCopyFromPrevious"
      (click)="onCopyDprForecastFromPreviousDpr()"
      mat-flat-button
      class="mat-secondary"
    >
      <mat-icon svgIcon="content-copy"></mat-icon>
      <span>{{StaticMessage.CopyFromPreviousDprTooltip | staticMessage}}</span>
    </button>
  </div>
</div>

<app-dpr-forecast-activities-grid
  [dprDetails]="dprDetails$ | async"
  [selectedSubproject]="selectedSubproject$ | async"
  [gridData]="gridData$ | async"
  [canEdit]="canEdit"
  (gridRegistered)="onGridRegistered($event)"
></app-dpr-forecast-activities-grid>
